import Vue from 'vue'
import App from './App.vue'
import router from './router'
// import 'swiper/dist/css/swiper.min.css'
// import 'swiper/dist/js/swiper.min.js'
import '@/assets/iconfont/iconfont.css'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import '@/assets/css/style.css'

// import '@/assets/js/flexible.js'
// import '@/assets/js/echarts-resize.js'
// import '@/assets/css/element.css'
Vue.use(ElementUI);


//表格滚动
// import scroll from 'vue-seamless-scroll'
// Vue.use(scroll)




Vue.config.productionTip = false
Vue.use(router);

new Vue({
    router,
    render: h => h(App),
}).$mount('#app')